import type { Chat, User } from '../types'

// userName собирает отображаемое имя пользователя с корректным фолбэком.
// Важно: используем `||`, а не `??`, чтобы пустые строки ("") тоже
// откатывались на следующий вариант (баг: у юзера first_name='' но есть username).
export function userName(u?: Partial<User> | null, fallback = 'Без имени'): string {
  if (!u) return fallback
  const full = [u.first_name, u.last_name].filter(Boolean).join(' ').trim()
  return full || u.username || fallback
}

// chatTitle возвращает заголовок чата: явный title -> имя собеседника -> тип-зависимый дефолт.
export function chatTitle(chat?: Partial<Chat> | null): string {
  if (!chat) return 'Чат'
  const fallback = chat.type === 'group' ? 'Группа' : chat.type === 'channel' ? 'Канал' : 'Чат'
  if (chat.title) return chat.title
  if (chat.peer) return userName(chat.peer, fallback)
  return fallback
}
